import { createIcon } from './icon';

export const ArrowUpRightIcon = createIcon(
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 11L11 5M11 5H6.33333M11 5V9.66667"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'ArrowUpRightIcon'
);
